
<portal to="dropdown">
  <div v-if="open" class="action-menu" ref="menu" :style="menuStyle" @click.stop>
    <div class="menu-item" @click="handleModify">
      <span class="menu-item-text">{{ $t('variableActions.modify') }}</span>
    </div>
    <div class="menu-item menu-item-danger" @click="handleDelete">
      <span class="menu-item-text">{{ $t('variableActions.delete') }}</span>
    </div>
  </div>
</portal>
